module.exports = __webpack_public_path__ + "0cceb1a43aedb8e14530f5f9f5816f55.png";